module.exports = __webpack_public_path__ + "static/media/2025-Summer-of-Cricket-Social-Image.3dfaf2f8.jpg";